import { render, staticRenderFns } from "./PartSearchTruckSelector.vue?vue&type=template&id=e4c565fa"
import script from "./PartSearchTruckSelector.ts?vue&type=script&lang=ts&external"
export * from "./PartSearchTruckSelector.ts?vue&type=script&lang=ts&external"
import style0 from "./PartSearchTruckSelector.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports